import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { WarningCircle } from "@phosphor-icons/react";
import api from "@/lib/api";
import { useWorkspace } from "@/context/WorkspaceContext";
import { Button } from "@/components/ui/button";

export default function PastDueBanner() {
  const { activeId } = useWorkspace();
  const navigate = useNavigate();
  const [pastDue, setPastDue] = useState(false);

  useEffect(() => {
    if (!activeId) { setPastDue(false); return; }
    api.get(`/subscription?workspace_id=${activeId}`)
      .then((r) => setPastDue(!!r.data.past_due))
      .catch(() => setPastDue(false));
  }, [activeId]);

  if (!pastDue) return null;

  return (
    <div data-testid="past-due-banner"
      className="mb-6 rounded-lg border border-destructive/40 bg-destructive/10 p-4 flex flex-col sm:flex-row sm:items-center gap-3">
      <WarningCircle size={22} weight="fill" className="text-destructive shrink-0" />
      <div className="flex-1">
        <p className="font-medium text-sm">Your last payment failed</p>
        <p className="text-xs text-muted-foreground">Update your payment method to keep your plan active and avoid losing access.</p>
      </div>
      <Button size="sm" variant="destructive" data-testid="past-due-update-btn" onClick={() => navigate("/billing")}>
        Update payment
      </Button>
    </div>
  );
}
